import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

const normalizeRoles = (data: Types.ReferenceData[]): Types.ReferenceData[] => {
  return data
}

interface PromotionCount {
  count: number,
  key: string,
}

interface ReferenceTemplate {
  name: string,
  promotions: string[],
  promotion_data?: PromotionCount[],
  shared: boolean,
  title: string,
}

type TemplatePayload = ReferenceTemplate[]
const normalizeTemplates =
  (templates: TemplatePayload, promotionTypes: Types.ReferenceData[]): Types.TemplateReferenceData[] => {
  return templates.map((template: ReferenceTemplate) => ({
    children: template.promotion_data.map((data: PromotionCount) => ({
      count: data.count,
      description: promotionTypes.filter((pt: Types.ReferenceData) => pt.name === data.key)[0].description,
      id: promotionTypes.filter((pt: Types.ReferenceData) => pt.name === data.key)[0].id,
      key: data.key,
    })),
    description: template.title || template.promotions.map((p: any) =>
      promotionTypes.filter((pt: Types.ReferenceData) => pt.name === p)[0].description).join('|'),
    id: 0,
    name: template.name,
    shared: template.shared,
  }))
}

const normalize = (data: any): Types.ReferenceState => {
  return {
    ...data,
    roles: normalizeRoles(data.roles),
    templates: normalizeTemplates(data.templates, data.promotion_types),
  }
}

export const reducer = (state: Types.ReferenceState, action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_REFERENCE_DATA):
      return normalize(action.payload.response)
    case Request.requestConstant(Constants.FETCH_REFERENCE_DATA):
    case Request.errorConstant(Constants.FETCH_REFERENCE_DATA):
      return Constants.emptyState
    default:
      return state || Constants.emptyState
  }
}



// WEBPACK FOOTER //
// ./src/pages/reference/reducer.ts